import styled from 'styled-components';

export interface IPublicPageContentWrapperProps {
  gridTemplateColumns?: string;
}

export const PublicPageContentWrapper = styled.div<IPublicPageContentWrapperProps>`
  display: flex;
  margin: auto;
  flex-direction: column;
  width: 100%;
  @media (min-width: ${({ theme }) => theme.breakpoints.Desktop}) {
    width: 80%;
  }
`;
